import React from 'react';
import {
  HashimotoTestInputType,
  withLoading,
  useTranslator,
} from '@front-activerse/common-components';
import { Container, Row, Col } from 'reactstrap';
import Layout from '../../Layout/Layout';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import EditTestsForm from './EditTestsForm';
import TitleBar from '../../Layout/TitleBar';

interface ITestsEditContainer {
  editMeasurement: (request: HashimotoTestInputType) => Promise<any>;
  measurement: {
    id: number;
    type: 'tsh' | 'ft3' | 'ft4' | 'antiTg' | 'antiTpo';
    value: number;
    testedAt: string;
  };
}

const TestsEditContainer: React.FC<ITestsEditContainer> = ({ editMeasurement, measurement }) => {
  const { t } = useTranslator();
  return (
    <Layout>
      <div className="page-template-lab-tests full-height2">
        <TitleBar>{t('testResultsEditing.navbarTitle')}</TitleBar>
        <section className="page-template-lab-tests">
          <Container className="py-md-4">
            <Row>
              <Col md={{ size: 10, offset: 1 }}>
                <div className="page-container">
                  <div className="lab-tests-container">
                    <Row>
                      <Col xl={{ size: 6, offset: 3 }}>
                        <EditTestsForm
                          editMeasurement={editMeasurement}
                          measurement={measurement}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </Layout>
  );
};

const Placeholder = <UniversalPlaceholder titleBar="" />;

export default withLoading(TestsEditContainer, Placeholder);
